import Input from './input';

export { Input };

export default Input;
